import React from 'react';

const BADGE_STYLES = {
  BROUILLON: 'bg-gray-100 text-gray-800',
  ACTIVE: 'bg-green-100 text-green-800',
  SUSPENDUE: 'bg-amber-100 text-amber-900',
  ARCHIVEE: 'bg-slate-100 text-slate-700',
  PLANIFIEE: 'bg-blue-100 text-blue-800',
  EXPIREE: 'bg-orange-100 text-orange-900',
};

/**
 * F2.2a — Badge statut (persisté ou dérivé PLANIFIEE/EXPIREE).
 */
export default function RecompenseStatusBadge({ code, label }) {
  const style = BADGE_STYLES[code] || 'bg-gray-100 text-gray-700';
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style}`}
      data-testid="recompense-status-badge"
    >
      {label || '—'}
    </span>
  );
}
